import React, { Component } from 'react';
import { renderApp, deepCloneObj } from './utils/utils';
import { getOrder } from './api/api';
import HelpPageInner from './help/HelpPage';
import {
  NO_ISSUE,
  OTHER_ISSUE_SELF_SERVE,
  itemIssueOptions,
  itemDecisionOptions,
  helpPageStructure,
} from './help/constants';
import { postIssueCredit } from './api/api';
import {
  orderId,
  customerName as windowCustomerName,
} from './constants/constants';

// help
const isAutoCreditable = Boolean(window.isAutoCreditable);

export class HelpWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order: {},
      prevPageStack: [],
      currentPage: 0,
      nextPageId: 1,
      disableNext: true,
      firstStepIssue: null, // first page
      orderDetails: {},
      itemsWithIssues: {},
      freeEntry: '', // text entry
      canIssueCredit: false,
      autoCreditAmount: 0,
      creditChoice: null,
      loading: true,
      skuLookupMap: {},
    };
    this.stateCpy = deepCloneObj(this.state);
    this.orderId = this.props.orderId || orderId;
    this.replaceStringConst = '&&&'; // see const.js, used it strings that need formatting based off state
    this.recordFirstIssue = this.recordFirstIssue.bind(this);
    this.recordOrderDetailIssues = this.recordOrderDetailIssues.bind(this);
    this.recordFreeTextEntry = this.recordFreeTextEntry.bind(this);
    this.recordCreditChoice = this.recordCreditChoice.bind(this);
    this.customerName = this.props.customerName || windowCustomerName;
  }

  componentDidMount() {
    if (!this.orderId && !this.state.loading) {
      return;
    }
    window.onbeforeunload = () => {
      return true;
    };
    this.getOrderAndMapOrderDetails();
    window.scrollTo(0, 0);
  }

  getOrderAndMapOrderDetails() {
    if (this.props.orderDetails && this.props.skuLookupMap) {
      this.setState({
        currentPage: 1,
        orderDetails: this.props.orderDetails,
        skuLookupMap: this.props.skuLookupMap,
      });
      return;
    }
    getOrder(this.orderId, 'all').then((data) => {
      this.setState({ loading: false, order: data }, () => {
        const [orderDetails, skuLookupMap] = this.mapAndFormatOrderDetails();
        this.setState({
          currentPage: 1,
          orderDetails: orderDetails,
          skuLookupMap: skuLookupMap,
        });
      });
    });
  }

  mapAndFormatOrderDetails() {
    if (!this.state.order) {
      return [];
    }
    let orderDetailsObj = {};
    let lookupTable = {};
    const groceryItems = this.state.order['grocery_items'];
    groceryItems.forEach((ele, idx) => {
      if (ele.products.length) {
        ele.products.forEach((product, pIdx) => {
          const issues = (product.issues || []).filter(
            (issue) => issue !== NO_ISSUE
          );
          const refundableQuantity = product.quantity - issues.length;
          // This for loop is to add all items (including multiple of the same items) separately into the list for rendering
          for (let i = 0; i < refundableQuantity; i++) {
            orderDetailsObj[`${product.id}-${pIdx}-${ele.id}-${idx}-${i}`] = {
              value: `${product.id}-${pIdx}-${ele.id}-${idx}-${i}`,
              optionText: `${product.brand_name} ${product.name}`,
              // Supplements cannot be auto-credited due to high item cost
              canIssueCredit: ele.name !== 'Supplements',
            };
          }
          lookupTable[product.id] = product;
        });
      }
    });
    return [orderDetailsObj, lookupTable];
  }

  getPageObj() {
    // get obj the inner part of the page
    if (this.state.currentPage < 1 && this.state.order) {
      return;
    }
    return Object.assign({}, helpPageStructure[this.state.currentPage]);
  }

  recordFirstIssue(value) {
    value = parseInt(value);
    if (!Number.isInteger(value) || value <= 0) {
      return;
    }
    let nextPage = 2;
    if (value === OTHER_ISSUE_SELF_SERVE) {
      nextPage = 6;
    }
    this.setState({
      firstStepIssue: value,
      nextPageId: nextPage,
      canIssueCredit: false,
      disableNext: false,
    });
  }

  recordOrderDetailIssues(value) {
    let itemsWithIssues = this.state.itemsWithIssues;
    itemsWithIssues[value]
      ? delete itemsWithIssues[value]
      : (itemsWithIssues[value] = true);
    let canIssueCredit = this.autoCreditResolution();
    const disableNextBtn = Object.keys(this.state.itemsWithIssues).length === 0;
    const nextPageId = canIssueCredit ? 4 : 6;
    this.setState({
      itemsWithIssues: itemsWithIssues,
      nextPageId: nextPageId,
      canIssueCredit: canIssueCredit,
      disableNext: disableNextBtn,
    });
  }

  recordFreeTextEntry(evt) {
    const regex = `^[\r|\n|a-zA-Z0-9,.!'&#@*()?"\$\/ ]*$`;
    let inputStr = evt.target.value; // excludes copy and paste case
    let lastChar = inputStr.slice(-1);
    const found = lastChar.match(regex);
    if (!found) {
      alert(
        `Sorry we don't allow ${lastChar} as an input \n Please delete it.`
      );
      return;
    }
    this.setState({ freeEntry: inputStr });
  }

  recordCreditChoice(value) {
    value = parseInt(value);
    if (!Number.isInteger(value)) {
      return;
    }
    const nextPageId = value === itemDecisionOptions[1]['value'] ? 5 : 6;
    this.setState({
      creditChoice: value,
      nextPageId: nextPageId,
      disableNext: false,
    });
  }

  gotoNextPage() {
    if (!this.state.nextPageId) {
      return;
    }
    if (this.state.nextPageId === 7 || this.state.nextPageId === 5) {
      this.autoCreditResolution(true);
      window.onbeforeunload = null;
      setTimeout(() => {}, 333);
    }
    let prevPageStack = this.state.prevPageStack;
    let disableNext = true;
    prevPageStack[0] != this.state.currentPage
      ? prevPageStack.unshift(this.state.currentPage)
      : null;
    let nextPageId = this.state.nextPageId;
    if (this.state.nextPageId === 6) {
      nextPageId = 7; // hack for no input on free-entry
      disableNext = false;
    }
    if (this.state.nextPageId === 4 && !this.state.canIssueCredit) {
      this.setState({ issue: true });
      nextPageId = 7;
    }
    window.scrollTo(0, 0);
    this.setState({
      prevPageStack: prevPageStack,
      currentPage: this.state.nextPageId,
      nextPageId: nextPageId,
      disableNext: disableNext,
    });
  }

  goToPrevPage() {
    if (!this.state.prevPageStack.length) {
      return;
    }
    const prevPageStack = this.state.prevPageStack;
    const nextPageId = this.state.currentPage;
    const currentPage = prevPageStack.shift();
    let disableNext = false;

    if (currentPage === 1) {
      const FreeEntryObj = { freeEntry: this.state.freeEntry };
      this.setState(
        Object.assign({}, deepCloneObj(this.stateCpy), FreeEntryObj)
      );
      this.getOrderAndMapOrderDetails();
      disableNext = true;
    }
    window.scrollTo(0, 0);
    this.setState({
      prevPageStack: prevPageStack,
      currentPage: currentPage,
      nextPageId: nextPageId,
      disableNext: disableNext,
    });
  }

  autoCreditResolution(sendRequest = false) {
    let shouldIssueCredit = true;
    if (!isAutoCreditable) {
      shouldIssueCredit = false;
    }
    if (this.state.firstStepIssue == OTHER_ISSUE_SELF_SERVE) {
      shouldIssueCredit = false;
    }

    const itemIds = Object.keys(this.state.itemsWithIssues);

    const itemsWithoutAutoCreditEligibility = Object.keys(
      this.state.orderDetails
    ).filter((key) => !this.state.orderDetails[key].canIssueCredit);
    const hasSelectedItemsWithoutAutoCreditEligibility = itemIds.some((id) =>
      itemsWithoutAutoCreditEligibility.includes(id)
    );

    if (hasSelectedItemsWithoutAutoCreditEligibility) {
      shouldIssueCredit = false;
    }

    const itemsAmount = itemIds.length;
    if (itemsAmount === 0 || itemsAmount > 3) {
      shouldIssueCredit = false;
    }
    let refundVal = 0;
    itemIds.forEach((ele) => {
      const id = ele.split('-')[0];
      const points = this.state.skuLookupMap[id]['points'];
      const baseRefundAmount = 4;
      let refundableAmount;
      if (points <= 2) {
        refundableAmount = baseRefundAmount;
      } else {
        refundableAmount = baseRefundAmount + (points - 2) * 2;
      }
      refundVal += refundableAmount;
    });
    if (refundVal > 24 || refundVal < 3) {
      shouldIssueCredit = false;
    }
    if (
      this.state.creditChoice === 0 &&
      typeof this.state.creditChoice === 'number'
    ) {
      shouldIssueCredit = false;
    }
    this.setState({
      autoCreditAmount: refundVal,
      canIssueCredit: shouldIssueCredit,
    });
    if (sendRequest) {
      const data = {
        order_id: this.orderId,
        item_issue: this.state.firstStepIssue,
        skus: Object.keys(this.state.itemsWithIssues).map(
          (ele) => ele.split('-')[0]
        ),
        free_text: this.state.freeEntry,
        credit_choice: this.state.creditChoice || false,
        should_issue_credit: shouldIssueCredit,
        auto_credit_amount: refundVal,
      };
      postIssueCredit(data);
    }
    return shouldIssueCredit;
  }

  stateReducer(obj) {
    switch (this.state.currentPage) {
      case 1:
        if (!obj) return;
        obj['selectedOptions'] = this.state.firstStepIssue
          ? itemIssueOptions[this.state.firstStepIssue]['value']
          : [];
        obj['actionFunc'] = this.recordFirstIssue;
        return obj;
      case 2:
        // TODO: first confirm it works, then remove the hack
        let displaySubtext = itemIssueOptions[this.state.firstStepIssue][
          'optionText'
        ]
          .split('  (')[0]
          .toLowerCase();
        obj['subtext'] = obj['subtext'].replace(
          this.replaceStringConst,
          displaySubtext
        );
        obj['displayOptions'] = this.state.orderDetails;
        obj['selectedOptions'] = Object.keys(this.state.itemsWithIssues);
        obj['actionFunc'] = this.recordOrderDetailIssues;
        return obj;
      case 4:
        obj['selectedOptions'] =
          this.state.creditChoice >= 0 ? this.state.creditChoice : [];
        obj['actionFunc'] = this.recordCreditChoice;
        obj['subtext'] = obj['subtext'].replace(
          this.replaceStringConst,
          this.state.autoCreditAmount
        );
        obj['displayOptions'][1]['optionText'] =
          'Yes, add $&&& to my account to solve this issue';
        obj['displayOptions'][1]['optionText'] = obj['displayOptions'][1][
          'optionText'
        ].replace(this.replaceStringConst, this.state.autoCreditAmount);
        return obj;
      case 5:
        obj['selectedOptions'] =
          this.state.creditChoice >= 0 ? this.state.creditChoice : [];
        obj['actionFunc'] = this.recordCreditChoice;
        obj['title'] = obj['title'].replace(
          this.replaceStringConst,
          this.customerName
        );
        obj['subtext'] = obj['subtext'].replace(
          this.replaceStringConst,
          this.state.autoCreditAmount
        );
        return obj;
      case 6:
        if (this.state.firstStepIssue === OTHER_ISSUE_SELF_SERVE) {
          obj['title'] = 'Can you tell us a bit more?';
          obj['subtext'] =
            'We’d love to know the details so we can improve your experience.';
        }
        return obj;
      case 7:
        obj['subtext'] = obj['subtext'].replace(
          this.replaceStringConst,
          this.customerName
        );
        return obj;
    }
  }

  render() {
    if (!this.state.order) {
      return <div>Loading...</div>;
    }
    let pageObj = this.getPageObj();
    if (!pageObj) {
      return <div>Loading...</div>;
    }
    pageObj = this.stateReducer(pageObj);
    return (
      <div className="help-page-wrapper">
        <HelpPageInner
          inputType={pageObj['inputType']}
          title={pageObj['title']}
          subtext={pageObj['subtext']}
          selectorOptions={pageObj['displayOptions']}
          selectorType={pageObj['selectType']}
          selectorAction={pageObj['actionFunc']}
          selectorSelectedOptions={pageObj['selectedOptions']}
          freeText={this.state.freeEntry}
          freeTextAction={this.recordFreeTextEntry}
          back={() => this.goToPrevPage()}
          next={() => this.gotoNextPage()}
          currentPage={this.state.currentPage}
          disableNext={this.state.disableNext}
          ordering={pageObj['ordering']}
        />
      </div>
    );
  }
}

renderApp(<HelpWrapper />, 'help-react-component');
